import * as React from "react"
import { Grid, ExpansionPanelDetails, IconButton } from '@material-ui/core';
import CountryModuleResponseComponent from './CountryModuleResponseComponent';
import PlayArrowIcon from '@material-ui/icons/PlayArrowOutlined';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import CheckIcon from '@material-ui/icons/Check';
import { getCountyModuleTypeDashboardCall } from 'src/effects/api/api.userDashboard';
import LoaderComponent from '../common/loader.component';
import { ModuleType } from 'src/constants/Enum/ModuleEnum';
import { Guid } from 'guid-typescript';
import { Link } from 'react-router-dom';

export default class RegionResponseAccordianComponent extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            countryModuleDetails: [],
            show: false
        }
        this.handleCountryModuleResponse = this.handleCountryModuleResponse.bind(this);
        this.handleCountryModuleResponseClose = this.handleCountryModuleResponseClose.bind(this);

    }

    handleCountryModuleResponse = (isModuleDialoadVisible: any, data: any) => {
        this.setState({ show: true })
        getCountyModuleTypeDashboardCall(data).then((resp: any) => {
            this.setState({
                [isModuleDialoadVisible]: !this.state[isModuleDialoadVisible],
                countryModuleDetails: resp.data.payload,
                show: false
            });
        });
    }

    handleCountryModuleResponseClose = (isModuleDialoadVisible: any) => {
        this.setState({ [isModuleDialoadVisible]: !this.state[isModuleDialoadVisible] });
    }

    UNSAFE_componentWillReceiveProps(props: any) {
        if (props && props.region) {
            props.region.countryAndModuleTypeData.forEach((element: any) => {
                return this.setState({
                    ["Gis_" + element.id]: false,
                    ["Cov_" + element.id]: false,
                    ["For_" + element.id]: false,
                })
            })
        }
    }

    render() {
        const isGIAvailable =  this.props.region.countryAndModuleTypeData.filter((x: any) => x.giPercentage >= 0).length > 0 ? true : false 
        return (
            <div>
                <LoaderComponent sending={this.state.show} />
                {this.props.region.countryAndModuleTypeData.map((country: any, countryKey: any) => {
                    return <ExpansionPanelDetails className="ExpansionPanelDetails" key={Guid.toString() + countryKey}>
                        <Grid container={true} spacing={8}>
                            <Grid item={true} xs={3}>
                                <div className="media-content">
                                    <div className={country && country.totalCompletionPercentage === 100 ? "media-left media-box media-box-success media-box-small" : "media-left media-box media-box-primary media-box-small"}>
                                        {country && country.totalCompletionPercentage === 100 ? <CheckIcon fontSize="large" /> : <PlayArrowIcon fontSize="large" />}
                                    </div>
                                    <div className="media-body">
                                        <h5 className="mt-0">{country.name}</h5>
                                    </div>
                                </div>
                            </Grid>

                            {isGIAvailable ?
                                <Grid item={true} xs={3} alignItems={"center"}>
                                    <div className="media-content">
                                        <Link to={{ pathname: `/survey/response/` + country.countryModuleMappingId }}>
                                            {country && country.giPercentage === 100 ? <CheckIcon fontSize="large" className="media-icon media-box-success" /> : <PlayArrowIcon fontSize="large" className="media-icon media-box-primary" />}
                                        </Link>
                                        <div className="media-body">
                                            <h5 className="mt-0">GIS</h5>
                                            {this.state["Gis_" + country.id] &&
                                                <CountryModuleResponseComponent
                                                    country={country}
                                                    moduleType={1}
                                                    modalState={"Gis_" + country.id}
                                                    showDialog={this.state["Gis_" + country.id]}
                                                    onClose={this.handleCountryModuleResponseClose}
                                                    countryModuleDetails={this.props.countryModuleDetails}
                                                    isAdmin={this.props.isAdmin}
                                                />}
                                        </div>
                                        {country && country.giPercentage !== 100 ?
                                            <div className="progress">
                                                <div className="progress-bar progress-bar-primary" style={{ width: (country && country.giPercentage) + '%' }} role="progressbar">
                                                    &nbsp;
                                         </div>
                                            </div> : ""}
                                    </div>
                                </Grid>
                                : ''
                            }
                            <Grid item={true} xs={isGIAvailable ? 3 : 4}>
                                <div className="media-content">
                                    {country && country.coveragePercentage === 100 ? <CheckIcon fontSize="large" className="media-icon media-box-success" /> : <PlayArrowIcon fontSize="large" className="media-icon media-box-primary" />}
                                    <div className="media-body">
                                        <h5 className="mt-0">Coverage</h5>
                                        <IconButton className="pull-right" color="inherit" aria-label="Open In New"
                                            onClick={this.handleCountryModuleResponse.bind(this, "Cov_" + country.id, {
                                                countryId: country.id,
                                                moduleTypeId: ModuleType.Coverage,
                                                surveyId: this.props.selectedSurvey.id
                                            })}>
                                            <OpenInNewIcon />
                                        </IconButton>

                                        {this.state["Cov_" + country.id] &&
                                            <CountryModuleResponseComponent
                                                country={country}
                                                moduleType={ModuleType.Coverage}
                                                modalState={"Cov_" + country.id}
                                                showDialog={this.state["Cov_" + country.id]}
                                                onClose={this.handleCountryModuleResponseClose}
                                                countryModuleDetails={this.state.countryModuleDetails}
                                                isAdmin={this.props.isAdmin}
                                            />
                                        }
                                    </div>
                                    {country && country.coveragePercentage !== 100 ?
                                        <div className="progress">
                                            <div className="progress-bar progress-bar-primary" style={{ width: (country && country.coveragePercentage) + '%' }} role="progressbar">
                                                &nbsp;
                                         </div>
                                        </div> : ""}
                                </div>
                            </Grid>

                            <Grid item={true} xs={isGIAvailable ? 3 : 4}>
                                <div className="media-content">
                                    {country && country.forecastPercentage === 100 ? <CheckIcon fontSize="large" className="media-icon media-box-success" /> : <PlayArrowIcon fontSize="large" className="media-icon media-box-primary" />}
                                    <div className="media-body">
                                        <h5 className="mt-0">Forecast</h5>
                                        <IconButton className="pull-right" color="inherit" aria-label="Open In New"
                                            onClick={this.handleCountryModuleResponse.bind(this, "For_" + country.id, {
                                                countryId: country.id,
                                                moduleTypeId: ModuleType.Forecast,
                                                surveyId: this.props.selectedSurvey.id
                                            })}>
                                            <OpenInNewIcon />
                                        </IconButton>

                                        {this.state["For_" + country.id] &&
                                            <CountryModuleResponseComponent
                                                country={country}
                                                moduleType={ModuleType.Forecast}
                                                modalState={"For_" + country.id}
                                                showDialog={this.state["For_" + country.id]}
                                                onClose={this.handleCountryModuleResponseClose}
                                                countryModuleDetails={this.state.countryModuleDetails}
                                                isAdmin={this.props.isAdmin}
                                            />
                                        }
                                    </div>
                                    {country && country.forecastPercentage !== 100 ?
                                        <div className="progress">
                                            <div className="progress-bar progress-bar-primary" style={{ width: (country && country.forecastPercentage) + '%' }} role="progressbar">
                                                &nbsp;
                                         </div>
                                        </div> : ""}
                                </div>
                            </Grid>
                        </Grid>

                    </ExpansionPanelDetails>

                })}

            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/AdminDashboardResponse/RegionResponseAccordianComponent.tsx